import { render } from "./MitmachenPage.vue?vue&type=template&id=9df63912"
import script from "./MitmachenPage.vue?vue&type=script&lang=js"
export * from "./MitmachenPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__